const companiesList = {
  listBreadcrumb: "الشركات",
  searchPlaceholder: "بحث الشركات",
  statusFilter: "الحالة",
  allStatuses: "الكل",
  createdFrom: "تاريخ الإنشاء من",
  createdTo: "تاريخ الإنشاء إلى",
  companyName: "اسم الشركة",
  companyId: "المعرّف",
  contactPerson: "جهة الاتصال",
  city: "المدينة",
  countryLabel: "الدولة",
  createdDate: "تاريخ الإنشاء",
  numberOfEvents: "عدد الفعاليات",
  status: "الحالة",
  active: "نشط",
  deactivated: "غير نشط",
  pending: "قيد الانتظار",
  rejected: "مرفوض",
  viewDetails: "عرض التفاصيل",
  deactivate: "إلغاء التفعيل",
  activate: "تفعيل",
  addCompany: "إضافة شركة",
  noCompaniesTitle: "لا توجد شركات بعد",
  noCompaniesDescription:
    "يبدو أنك لم تضف أي شركات إلى قائمتك. ابدأ بإنشاء أول ملف شركة لإدارة الفعاليات والمتقدمين.",
  showingRange: "عرض {from}–{to} من أصل {total} شركة",
  editPageTitle: "تعديل الشركة",
  editPageHint: "حدّث حقول اسم الشركة أدناه.",
  nameEn: "الاسم (إنجليزي)",
  nameAr: "الاسم (عربي)",
  companyProfile: "ملف الشركة",
  overviewTab: "نظرة عامة",
  financialsPayrollTab: "المالية والرواتب",
  pendingRequestsTab: "طلبات معلقة",
  clientsTab: "العملاء",
  teamPermissionsTab: "الفريق والصلاحيات",
  logsTab: "السجلات",
  overviewStatTotalEvents: "إجمالي الفعاليات",
  overviewStatOngoingEvents: "فعاليات قيد التنفيذ",
  overviewStatTotalRevenue: "إجمالي الإيرادات",
  overviewStatTotalApplicants: "إجمالي المتقدمين",
  overviewStatCurrency: "ر.س",
  editCompanyProfile: "تعديل ملف الشركة",
  generalInformation: "معلومات عامة",
  englishName: "الاسم بالإنجليزية",
  arabicName: "الاسم بالعربية",
  cityLabel: "المدينة",
  fullName: "الاسم الكامل",
  mobileNumber: "رقم الجوال",
  emailAddress: "البريد الإلكتروني",
  commercialRecordLabel: "السجل التجاري",
  cannotBeEdited: "لا يمكن تعديله",
  cannotBeEditedEmail: "لا يمكن تعديله",
  documents: "المستندات",
  delegationDocument: "وثيقة التفويض",
  idDocument: "وثيقة الهوية",
  commercialRecordDocument: "السجل التجاري (وثيقة السجل التجاري)",
  download: "تنزيل",
  replace: "استبدال",
  removeDocument: "إزالة",
  confirmRemoveTitle: "إزالة المستند",
  confirmRemoveBody: "هل أنت متأكد أنك تريد إزالة هذا المستند؟",
  logoUploadHint: "JPG أو PNG أو SVG. الحجم الأقصى 2 ميجابايت.",
  logoUploadChange: "تغيير",
  saveChanges: "حفظ التغييرات",
  logoUploadFailed: "تعذّر رفع الشعار. حاول مرة أخرى.",
  commercialRecordUploadFailed: "تعذّر رفع السجل التجاري. حاول مرة أخرى.",
  delegationDocumentUploadFailed:
    "تعذّر رفع وثيقة التفويض. حاول مرة أخرى.",
  idDocumentUploadFailed: "تعذّر رفع مستند الهوية. حاول مرة أخرى.",
  pendingProfileRequest:  "طلب الملف الشخصي معلّق",
  reviewRequest: "مراجعة الطلب",
  pendingProfileUpdateRequest: "طلب تحديث الملف الشخصي معلّق",
  submittedOn: "تم الإرسال في {date}",
  reviewProfileUpdateRequest: "مراجعة طلب تحديث الملف الشخصي",
  approveUpdate: "الموافقة على التحديث",
  rejectUpdateRequest: "رفض الطلب",
  changesSummary: "ملخص التغييرات",
  changesSummaryLegendNewTitle: "الحقول المميّزة",
  changesSummaryLegendNewDesc: "تعرض القيم الجديدة المطلوب اعتمادها",
  changesSummaryLegendOldTitle: "النص المشطوب",
  changesSummaryLegendOldDesc: "تعرض القيم السابقة التي سيتم استبدالها",
  rejectEditRequestModalTitle: "رفض طلب التعديل",
  rejectEditRequestModalDescription:
    "يُرجى إدخال سبب لرفض هذا التحديث. ستظهر هذه الملاحظة لمسؤول الشركة.",
  rejectEditRequestReasonLabel: "السبب",
  rejectEditRequestReasonPlaceholder:
    "مثال: يُرجى تقديم نسخ أوضح من المستندات...",
  confirmRejectEditRequest: "تأكيد الرفض",
  totalChanges: "إجمالي التغييرات",
  totalChangesFields: "{count} حقول",
  editRequestLoadError: "تعذّر تحميل طلب التعديل. يُرجى المحاولة مرة أخرى.",
  noActiveEditRequest: "لا يوجد طلب تحديث ملف قيد الانتظار لهذه الشركة.",
  documentUpdated: "تم تحديث المستند",
  documentChanges: "تغييرات المستندات",
  documentType: "نوع المستند",
  currentDocument: "المستند الحالي",
  newSubmission: "الإرسال الجديد",
  previewNew: "معاينة الجديد",
  viewCurrent: "عرض الحالي",
  viewOldDoc: "عرض المستند القديم",
  noUpdateSubmittedForDocument: "لم يتم إرسال تحديث لهذا المستند",
  requestAccountDeletion: "طلب حذف الحساب",
};

export default companiesList;
